<p>{{ 'exportLayerEntitiesByDrawnArea' | transloco }} {{ 'onlyGeometricEntitiesWillBeExported' | transloco }}</p>
@if (!dataExportService.isMapFiltered()) {
    <div class="no-map-zone-warning">
        {{ 'noMapZoneSelected' | transloco }}
    </div>
}
<app-expansion-panel [isExpanded]="true">
    <div
        class="!text-sm"
        header>
        {{ 'layers' | transloco }}
    </div>
    <div
        class="flex flex-col gap-2"
        content>
        @if (layerNames().length) {
            <app-custom-search
                [isNarrowSearchBar]="true"
                (resetSearch)="handleSearch('')"
                (search)="handleSearch($event)" />
        }

        @if (!isLoading()) {
            <div
                [class]="
                    layerNames().length
                        ? 'grid grid-cols-3 overflow-y-auto overflow-x-hidden max-h-80 gap-1.5'
                        : 'w-full flex justify-center'
                ">
                @for (layer of layerRows(); track layer.layerName) {
                    <div
                        class="flex flex-row gap-1 p-1 items-center text-subtitle-1 cursor-pointer"
                        [class.bg-custom-light-blue]="layer.isChecked"
                        (click)="updateSelectedLayer(layer.layerIds, layer.checkboxState)">
                        <app-checkbox [checkboxState]="layer.checkboxState" />

                        <span [class.text-custom-blue]="layer.isChecked">{{ layer.layerName }}</span>
                    </div>
                } @empty {
                    <span class="text-base w-full text-center">{{ 'noLayerOnProject' | transloco }}</span>
                }
            </div>
        } @else {
            <app-loading />
        }
    </div>
</app-expansion-panel>
